// Cloud Functions, through Track's own door. In the read-only preview every
// callable is refused: callables write (directly or by logging) far more often
// than they read, so none is trusted to be harmless.
// Named, not `export *`: the deploy bundler can't see names through a
// star re-export of a remote module (v4.0.0 launch, 23/10/2026). Every name
// firebase-functions 10.14.1 exports, minus the ones guarded below.
export {
  connectFunctionsEmulator, getFunctions, httpsCallableFromURL,
} from 'https://www.gstatic.com/firebasejs/10.14.1/firebase-functions.js';
import * as F from 'https://www.gstatic.com/firebasejs/10.14.1/firebase-functions.js';
import { READ_ONLY, ReadOnlyPreview } from '../preview.js';

export const httpsCallable = READ_ONLY
  ? () => () => Promise.reject(new ReadOnlyPreview('That action'))
  : F.httpsCallable;
